import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Rect } from "react-native-svg";

export const IconDotGrid1x3VerticalTight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconDotGrid1x3VerticalTight"><Rect x="10" y="3" width="4" height="4" rx="2" fill="currentColor"/><Rect x="10" y="10" width="4" height="4" rx="2" fill="currentColor"/><Rect x="10" y="17" width="4" height="4" rx="2" fill="currentColor"/></CentralIconBase>;
});

export default IconDotGrid1x3VerticalTight;
